import React, { useState } from "react";
import { Grid, Checkbox, FormControlLabel } from "@mui/material";

function StatsCoordinatorStructure() {
  const [areaChecked, setAreaChecked] = useState(false);
  const [regionChecked, setRegionChecked] = useState(false);
  const [chapterChecked, setChapterChecked] = useState(false);
  const [districtChecked, setDistrictChecked] = useState(false);

  return (
    <Grid container rowSpacing={4} columnSpacing={5}>
      {/* ... Other input fields ... */}
      <Grid item xs={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={areaChecked}
              onChange={(e) => setAreaChecked(e.target.checked)}
              color="primary"
            />
          }
          label="Area"
        />
      </Grid>
      <Grid item xs={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={regionChecked}
              onChange={(e) => setRegionChecked(e.target.checked)}
              color="primary"
            />
          }
          label="Region"
        />
      </Grid>
      <Grid item xs={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={chapterChecked}
              onChange={(e) => setChapterChecked(e.target.checked)}
              color="primary"
            />
          }
          label="Chapter"
        />
      </Grid>
      <Grid item xs={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={districtChecked}
              onChange={(e) => setDistrictChecked(e.target.checked)}
              color="primary"
            />
          }
          label="District"
        />
      </Grid>
    </Grid>
  );
}

export default StatsCoordinatorStructure;
